import React from 'react';
import { StarIcon } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function TestimoniosSection() {
  const testimonios = [{
    name: 'Carlos M.',
    location: 'Madrid, España',
    quote: 'Llevaba años estancado en mis ingresos. A los 14 días de escuchar el audio y aplicar el manual, cerré el contrato más grande de mi vida. Parece magia, pero es frecuencia.',
    rating: 5
  }, {
    name: 'Laura V.',
    location: 'Bogotá, Colombia',
    quote: 'Mi relación con el dinero era de puro estrés. El Código 888 reprogramó mi ansiedad. Ahora el dinero fluye hacia mí de formas inesperadas. Totalmente recomendado.',
    rating: 5
  }, {
    name: 'Alejandro R.',
    location: 'Miami, USA',
    quote: "Era escéptico sobre la 'programación cuántica'. Pero los resultados hablan por sí solos. Multipliqué mis fuentes de ingresos en menos de un mes. Es una inversión ridícula para lo que obtienes.",
    rating: 5
  }];
  const [headerRef, headerInView] = useInView();
  const [cardsRef, cardsInView] = useInView();
  return <section id="testimonios" className="py-16 sm:py-24 px-4 sm:px-[5%] bg-dark relative border-t border-white/5" data-id="element-174">
      <div className="max-w-[1200px] mx-auto" data-id="element-175">
        <div ref={headerRef} className={`text-center mb-16 will-animate animate-fadeIn ${headerInView ? 'is-visible' : ''}`} data-id="element-176">
          <h2 className="font-serif text-3xl md:text-5xl font-black mb-6" data-id="element-177">
            RESULTADOS <span className="text-gold" data-id="element-178">CUÁNTICOS</span>
          </h2>
          <p className="text-lg opacity-80 max-w-2xl mx-auto" data-id="element-179">
            Personas reales experimentando transformaciones financieras reales
            al sintonizar con la frecuencia correcta.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-180">
          {testimonios.map((testimonio, index) => <div key={index} className={`bg-white/5 border border-gold/10 p-8 rounded-xl relative will-animate animate-fadeIn delay-${(index + 1) * 100} ${cardsInView ? 'is-visible' : ''}`} role="article" aria-label={`Testimonio de ${testimonio.name}`} data-id="element-181">
              <div className="flex gap-1 mb-6" role="img" aria-label={`${testimonio.rating} de 5 estrellas`} data-id="element-182">
                {[...Array(testimonio.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-gold text-gold" aria-hidden="true" data-id="element-183" />)}
              </div>
              <blockquote className="opacity-95 leading-relaxed mb-8 italic" data-id="element-184">
                "{testimonio.quote}"
              </blockquote>
              <div className="flex items-center gap-4 border-t border-white/10 pt-6" data-id="element-185">
                <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center font-bold text-gold" aria-hidden="true" data-id="element-186">
                  {testimonio.name.charAt(0)}
                </div>
                <div data-id="element-187">
                  <h4 className="font-bold" data-id="element-188">{testimonio.name}</h4>
                  <p className="text-xs text-white/60 uppercase tracking-wider" data-id="element-189">
                    {testimonio.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}